import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step12 } from '../../../../shared/models/component-messages/mapaIN/step12';
import { CTRL_8 } from '../../../validators/8/ctrl8';
import { CTRL_9 } from '../../../validators/9/ctrl9';
import { TypeAdresseComplete } from '../models/TypeAdresseComplete';
import { MapaINControlNames } from '../service/mapaINControleNames';
@Component({
  selector: 'app-type-adresse-complete',
  templateUrl: './type-adresse-complete.component.html'
})
export class TypeAdresseCompleteComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeAdresseComplete';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() filtreRG: string;
	@Input() nbIteration: number;
	
	@Input() typeAdresseComplete: TypeAdresseComplete;

  public step12 = new Step12();

  constructor() { }

  public ngOnInit() {}
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

